import React, { Component } from 'react';
import { connect } from 'react-redux';

import { saveDisplayAnnotationColorChange } from 'PipeRouter';
import FilterHighlightOptionsViews from './views';


class FilterHighlightOptions extends Component {
  onDisplayAnnotationColorChange = event => {
    const { displayAnnotationColors, saveDisplayAnnotationColorChange } = this.props;
    const { id, checked } = event.target;

    const updateDisplayColors = displayAnnotationColors.map(color =>
      color.markerId === id && !color.disabled
        ? { ...color, display: checked }
        : color
    );

    saveDisplayAnnotationColorChange(updateDisplayColors);
  }

  render() {
    const viewProps = {
      displayAnnotationColors: this.props.displayAnnotationColors,
      onDisplayAnnotationColorChange: this.onDisplayAnnotationColorChange
    };

    return <FilterHighlightOptionsViews { ...viewProps } />
  }
}

function mapStateToProps(state) {
  const { notebook:{ displayAnnotationColors }} = state;
  return { displayAnnotationColors };
}


export default connect(mapStateToProps, {
  saveDisplayAnnotationColorChange
})(FilterHighlightOptions);
